import NoticeTextArea from "@/view/alarm/NoticeTextArea";
import NoticeHistoryListView from "@/view/alarm/NoticeHistoryListView";

export const NoticeView = () => {
    return (
        <div className="flex gap-4 p-5 overflow-hidden">
            <div className="w-full md:w-1/2 p-1">
                <NoticeTextArea />
            </div>
            <div className="w-full md:w-1/2 p-1">
                <NoticeHistoryListView />
            </div>
        </div>
    )
}

export default NoticeView;